import layout from '@/layout'

export default {
  path: '/operation',
  component: layout,
  redirect: '/operation/shopManage',
  name: 'shopManage',
  meta: {
    title: '运营设置',
    icon: 'setting-config'
  },
  children: [
    {
      path: '/operation/shopManage',
      component: () => import('@/views/operation/tenantManage/index.vue'),
      meta: {
        title: '商城设置',
        icon: 'weixin-market'
      }
    }
  ]
}
